import { useEffect, useState } from "react";
import { whatsappUrl } from "@/lib/whatsapp";

// Inline SVG to avoid pulling an extra icon library and to control the colour precisely.
function WhatsappGlyph({ size = 22 }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
      <path d="M16.001 3C9.373 3 4 8.372 4 14.999c0 2.36.69 4.617 1.997 6.563L4 28l6.59-1.954A12.93 12.93 0 0 0 16 27c6.628 0 12-5.372 12-11.999C28 8.372 22.628 3 16.001 3zm0 21.802a9.78 9.78 0 0 1-4.985-1.36l-.358-.213-3.91 1.16 1.179-3.81-.234-.39a9.785 9.785 0 0 1-1.5-5.19c0-5.41 4.4-9.81 9.81-9.81 5.41 0 9.808 4.4 9.808 9.811 0 5.41-4.398 9.802-9.81 9.802zm5.379-7.345c-.295-.148-1.745-.86-2.015-.96-.27-.099-.467-.148-.665.149-.197.296-.762.96-.935 1.158-.173.197-.345.222-.64.074-.295-.148-1.243-.458-2.366-1.46-.875-.78-1.466-1.745-1.639-2.04-.172-.296-.018-.456.13-.604.133-.133.295-.345.443-.518.148-.173.197-.296.295-.493.099-.197.05-.37-.024-.518-.074-.148-.665-1.603-.911-2.196-.24-.577-.484-.499-.665-.508l-.566-.01c-.197 0-.518.074-.789.37-.27.296-1.034 1.01-1.034 2.464 0 1.454 1.06 2.858 1.208 3.055.148.197 2.087 3.187 5.062 4.467.708.305 1.26.487 1.69.624.71.226 1.356.194 1.867.118.57-.085 1.745-.713 1.991-1.402.247-.69.247-1.28.173-1.403-.074-.123-.27-.197-.567-.345z" />
    </svg>
  );
}

export default function WhatsappFab() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 600);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <a
      href={whatsappUrl()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Discuter sur WhatsApp"
      className="fixed bottom-6 left-6 z-40 group flex items-center gap-3 pl-3 pr-5 py-3 bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:shadow-xl hover:shadow-[#25D366]/40 hover:-translate-y-0.5 transition-all duration-300"
      style={{ borderRadius: 999 }}
    >
      <span className="flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
        <WhatsappGlyph size={20} />
      </span>
      <span className="hidden sm:inline text-sm font-medium tracking-wide">
        Parler sur WhatsApp
      </span>
      <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-white animate-ping opacity-75" />
      <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-white" />
    </a>
  );
}

export { WhatsappGlyph };
